import Vue from 'vue'
import Router from 'vue-router'
import prismComponent from '@/components/prism'
//-------------------------Users------------------------------------------------------------------------------
const UserLogin = () => import('@/components/prism/Users/login')
const QickoUserLogin = () => import('@/components/prism/Users/login_quicko')
const recorder = () => import('@/components/prism/Users/recorder')
const UserAdminLogin = () => import('@/components/prism/Users/admin_login')
const UserRegisterStepMinusTwo = () => import('@/components/prism/Users/register_step-2')
const UserRegisterStepMinusOne = () => import('@/components/prism/Users/register_step-1')
const UserRegister = () => import('@/components/prism/Users/register')
const api = () => import('@/components/prism/Users/api')
const UserRegisterStepZero = () => import('@/components/prism/Users/register_step0')
const UserRegisterStepOne = () => import('@/components/prism/Users/register_step1')
const UserRegisterStepOnedotFive = () => import('@/components/prism/Users/register_step1-5')
const UserRegisterStepTwo = () => import('@/components/prism/Users/register_step2')
const UserRegisterStepThree = () => import('@/components/prism/Users/register_step3')
const UserRegisterStepfour = () => import('@/components/prism/Users/register_step4')
const UserRegisterStepfive = () => import('@/components/prism/Users/register_step5')
const IPVRedirect = () => import ('@/components/prism/IPVRedirect/IPVRedirect');

const pledge_res = () => import('@/components/prism/Users/pledge_res')
const UserRegisterStepSix = () => import('@/components/prism/Users/register_step6')
const documentVerification = () => import('@/components/prism/Users/documentVerification')
const coupon_list = () => import('@/components/prism/Users/coupon_list')
const coupon_history_list = () => import('@/components/prism/Users/coupon_history_list')
const digi_response = () => import('@/components/prism/Users/digi_response')
const Payment = () => import('@/components/prism/shared/payment')

const Downtime = () => import('@/components/common/DownTime')

const UserDashboard = () => import('@/components/prism/Users/dashboard')
const UserProfile = () => import('@/components/prism/Users/profile')

const videos = () => import('@/components/prism/video/Video')

const changePassword = () => import('@/components/prism/Users/change_password')
//-------------------------Accounts----------------------------------------------------------------------------
const AccountForgotPassword = () => import('@/components/prism/Accounts/forgot_password')
const AccountResetPassword = () => import('@/components/prism/Accounts/reset_password')
const AccountOpenDemat = () => import('@/components/prism/Accounts/open_demat_account')
const AccountEnableExchange = () => import('@/components/prism/Accounts/enable_exchange')
const ResetPasswordLink = () => import('@/components/prism/Accounts/reset_password_link')


const addNominee = () => import('@/components/prism/shared/services/addNominee')


//-------------------------ManageAccounts----------------------------------------------------------------------
const ManageAccountFinancialLedger = () => import('@/components/prism/ManageAccounts/financial_ledgers')

const ManageAccountManagementAcconts = () => import('@/components/prism/ManageAccounts/management_acconts')
const ManageAccountServicesAcconts = () => import('@/components/prism/ManageAccounts/services-account')
const AccountCoupons = () => import('@/components/prism/ManageAccounts/account-coupons')
const ProfileUser = () => import('@/components/prism/ManageAccounts/user-profile')
const FAQ = () => import('@/components/prism/ManageAccounts/faq')

const FinancialLedger = () => import('@/components/prism/ManageAccounts/financial_ledger')
const TaxReport = () => import('@/components/prism/ManageAccounts/tax_report')

const ManageAccountNetPositions = () => import('@/components/prism/ManageAccounts/net_positions')
const ManageAccountKsoftNetPositions = () => import('@/components/prism/ManageAccounts/ksoft_net_positions')

const ManageAccountKsoftNetHoldings = () => import('@/components/prism/ManageAccounts/ksoft_net_holdings')

const ManageAccountTradeConfirmation = () => import('@/components/prism/ManageAccounts/trade_confirmation')

const ManageAccountTaxReports = () => import('@/components/prism/ManageAccounts/tax_reports')
const ManageAccountKsoftTaxReports = () => import('@/components/prism/ManageAccounts/ksoft_tax_reports')


const ManageAccountContractNote = () => import('@/components/prism/ManageAccounts/contract_notes')
const ManageAccountClosedPositions = () => import('@/components/prism/ManageAccounts/closed_positions')
//-------------------------Deposits----------------------------------------------------------------------------
const DepositHistory = () => import('@/components/prism/Deposits/history')

//-------------------------Funds-------------------------------------------------------------------------------
const FundPayin = () => import('@/components/prism/Funds/payin')
const FundPayout = () => import('@/components/prism/Funds/payout')
const mutualFund = () => import('@/components/prism/Funds/mutual_fund')
const mandate = () => import('@/components/prism/Funds/mandate')
const exsis_portfolio = () => import('@/components/prism/Funds/exsis_portfolio')


const create_mandate = () => import('@/components/prism/Funds/create_mandate')
//-------------------------Leverages---------------------------------------------------------------------------
const Leveragecompare = () => import('@/components/prism/Leverages/compare')
const Leveragehistory = () => import('@/components/prism/Leverages/history')

const LeverageIndex = () => import('@/components/prism/Leverages/leverage_index')
//-------------------------Services----------------------------------------------------------------------------
const ServicesIndex = () => import('@/components/prism/Services/index')
//-------------------------MarketDetails----------------------------------------------------------------------
const MarketDetails = () => import('@/components/prism/MarketDetails/market_details')
//-------------------------mcx_ncdex----------------------------------------------------------------------------
const McxNcdex = () => import('@/components/prism/Segments/mcx_ncdex') 
const shoonya = () => import('@/components/prism/Segments/shoonya') 

//--------------------------------ib-list-----------------------------------
const Ib_list = () => import('@/components/prism/ib-list/list')

const Ib_list_new = () => import('@/components/prism/ib-list/list_new')

const couponList = () => import('@/components/prism/Coupon/index')

const comingShoonya = () => import('@/components/prism/shared/coming-shoonya')
const unauthorized = () => import('@/components/prism/shared/unauthorized')

const financialTest = () => import('@/components/prism/shared/services/financial_statement_test')

const PaymentStatus = () => import('@/components/prism/shared/payment/paymentStatus')

const HdfcTransactions = () => import('@/components/prism/shared/transactions/hdfcTransactions')
const notFound = () => import('@/components/prism/not-found')

const grossIncome = () => import('@/components/prism/shared/services/gross_annual_income')

let isDownTime = false;

// export default 
const router = new Router({
  mode: 'history',
  routes: isDownTime ?  [
    {
        path: '/downtime',
        name: 'financial.Test',
        component: Downtime
    },
    {
        path: '/',
        name: 'MarketDetails.MarketDetails',
        redirect: to => {
            return { path: '/downtime'}
        }
    },
    {
        path: '/payment-status',
        name: 'Payment.PaymentStatus',
        component: PaymentStatus,
    },
    {
        path: '/transaction-list',
        name: 'Transaction.hdfcTransactions',
        component: HdfcTransactions,
    },
    {
        path: '*',
        name: 'MarketDetails.MarketDetails',
        redirect: to => {
            return { path: '/downtime'}
        }
    },
] : [
    {
        path: '/financial-test',
        name: 'financial.Test',
        component: financialTest
    },
    {
        path: '/payment-status',
        name: 'Payment.PaymentStatus',
        component: PaymentStatus,
    },
    {
        path: '/transaction-list',
        name: 'Transaction.hdfcTransactions',
        component: HdfcTransactions,
    },
	//-------------------------Users------------------------------------------------------------------------------
	{
      path: '/video',
      name: 'video.videos',
      component: videos
    },
	{
      path: '/',
      name: 'Users.UserLogin',
      component: UserLogin
    },  
    {
        path: '/ipv-redirect',
        name: 'Users.IPVRedirect',
        component: IPVRedirect
    },
    {
      path: '/quicko-login',
      name: 'Users.QickoUserLogin',
      component: QickoUserLogin
    },
	{
      path: '/recorder',
      name: 'Users.recorder',
      component: recorder
    },
    {
      path: '/admin-login',
      name: 'Users.UserAdminLogin',
      component: UserAdminLogin
    },
	{
      path: '/register',
      name: 'Users.UserRegister',
      component: UserRegister
    },
    {
      path: '/unauthorized',
      name: 'Users.unauthorized',
      component: unauthorized
    },
	//-------------------------account------------------------------------------------------------------------------
	
	{
		path: '/Accounts/reset-password/:secureKey',
		name: 'Accounts.AccountResetPassword',
		component: AccountResetPassword,
	},
    {
      path: '/forgot/password/:forgothash',
      name: 'Accounts.ResetPasswordLink',
      component: ResetPasswordLink,     
    },
    {
      path: '/Accounts/forgot-password/',
      name: 'Accounts.AccountForgotPassword',
      component: AccountForgotPassword,     
    },
    {
      path: '/payment',
      name: 'Payment',
      component: Payment,     
    },

        //-----------------------------Shoonya Coming---------------------

        {
            path: '/bo/reports',
            name: 'comingShoonya',
            component: comingShoonya
        },
        {
            path: '/portfolio/pledge',
            name: 'comingShoonya2',
            component: comingShoonya
        },
        {
            path: '/shoonya-referal',
            name: 'comingShoonya3',
            component: comingShoonya
        },
        {
            path: '/services/mobile/requestServiceElement',
            name: 'comingShoonya4',
            component: comingShoonya
        },
    
	//----------------------------------------Inner Pages--------------------------------------------------------------------
    {
		path:'/',
		component: prismComponent,
		children:[
        {
            path: '/Segments/segment',
            name: 'Segments.McxNcdex',
            props : true,
            component: McxNcdex
        },
        {
      path: '/add-nominee',
      name: 'addNominee',
      component: addNominee
    },
		//-------------------------Users------------------------------------------------------------------------------
		{
            path: '/Users/register/step-2',
            name: 'Users.UserRegisterStepMinusTwo',
            component: UserRegisterStepMinusTwo
        },
        {
            path: '/Users/register/step-1',
            name: 'Users.UserRegisterStepMinusOne',
            component: UserRegisterStepMinusOne
        }, 

        
        {
            path: '/coupon-list',
            name: 'Users.coupon_list',
            component: coupon_list
        }, 
        {
            path: '/api',
            name: 'Users.api',
            component: api
        },
        {
            path: '/cdsl/pledge',
            name: 'Users.pledge_res',
            component: pledge_res
        },

        {
            path: '/coupon-list/:id',
            name: 'Users.coupon_data',
            component: coupon_list
        },
        {
            path: '/transaction-history',
            name: 'Users.coupon_history_list',
            component: coupon_history_list
        },
		{
            path: '/Users/register/step0',
            name: 'Users.UserRegisterStepZero',
            component: UserRegisterStepZero
        },
        {
            path: '/Users/register/step1',
            name: 'Users.UserRegisterStepOne',
            component: UserRegisterStepOne
        },
        {
            path: '/Users/register/step1-5',
            name: 'Users.UserRegisterStepOnedotFive',
            component: UserRegisterStepOnedotFive
        },
        {
            path: '/Users/register/step2',
            name: 'Users.UserRegisterStepTwo',
            component: UserRegisterStepTwo
        }, 
        {
            path: '/Users/register/step3',
            name: 'Users.UserRegisterStepThree',
            component: UserRegisterStepThree
        },
         {
            path: '/digilocker-response',  
            name: 'Users.digi_response',
            component: digi_response
        },
		{
            path: '/shoonya',
            name: 'shoonya',
            component: shoonya
        },
        {
            path: '/Users/register/step4',
            name: 'Users.UserRegisterStepfour',
            component: UserRegisterStepfour
        },
        {
            path: '/Users/register/step5',
            name: 'Users.UserRegisterStepfive',
            component: UserRegisterStepfive
        },
        {
            path: '/Users/register/step6',
            name: 'Users.UserRegisterStepSix',
            component: UserRegisterStepSix
        },
        {
            path: '/Users/dashboard',
            name: 'Users.UserDashboard',
            component: UserDashboard,
        },
		{
            path: '/Users/profile',
            name: 'Users.UserProfile',
            component: UserProfile
        },

        {
            path: '/required/document/verification',
            name: 'Users.documentVerification',
            component: documentVerification
        },
        {
          path: '/change-password',
          name: 'Users.changePassword',
          component: changePassword
        },

        
		//-------------------------account------------------------------------------------------------------------------
        {
            path: '/Accounts/open-demat',
            name: 'Accounts.AccountOpenDemat',
            component: AccountOpenDemat,
        },
        {
            path: '/Accounts/enable-exchange',
            name: 'Accounts.AccountEnableExchange',
            component: AccountEnableExchange,
        },
		//-------------------------ManageAccounts------------------------------------------------------------------------------
        {
            path: '/ManageAccounts/financial-ledger',
            name: 'ManageAccounts.ManageAccountFinancialLedger',
            component: ManageAccountFinancialLedger,
        },

        //new 
        // {
        //     path: '/ManageAccounts/management-acconts',
        //     name: 'ManageAccounts.ManageAccountManagementAcconts',
        //     component: ManageAccountManagementAcconts,
        // },
        // {
        //     path: '/ManageAccounts/services-account',
        //     name: 'ManageAccounts.ManageAccountManagementAcconts',
        //     component: ManageAccountServicesAcconts,
        // },
        {
            path: '/ManageAccounts/account-coupons',
            name: 'ManageAccounts.AccountCoupons',
            component: AccountCoupons,
        },
        {
            path: '/ManageAccounts/user-profile',
            name: 'ManageAccounts.ProfileUser',
            component: ProfileUser,
        },
        // {
        //     path: '/ManageAccounts/faq',
        //     name: 'ManageAccounts.FAQ',
        //     component: FAQ,
        // },
        {
            path: '/faq',
            name: 'faq.FAQ',
            component: FAQ,
        },
        //nwe 

        {
            path: '/financial-ledger',
            name: 'ManageAccounts.FinancialLedger',
            component: FinancialLedger,
        }, 

        {
            path: '/tax-report',
            name: 'ManageAccounts.TaxReport',
            component: TaxReport,
        },


        //======================portfolio(holdings)=================================
        {
            path: '/ManageAccounts/portfolio',
            name: 'ManageAccounts.ManageAccountNetPositions',
            component: ManageAccountNetPositions,
        },

        {
            path: '/ManageAccounts/ksoft-portfolio',
            name: 'ManageAccounts.ManageAccountKsoftNetPositions',
            component: ManageAccountKsoftNetPositions,
        },

        {
            path: '/ManageAccounts/ksoft-holdings',
            name: 'ManageAccounts.ManageAccountKsoftNetHoldings',
            component: ManageAccountKsoftNetHoldings,
        },


        //======================trade-confirmation==================================
        {
            path: '/ManageAccounts/trade-confirmation',
            name: 'ManageAccounts.ManageAccountTradeConfirmation',
            component: ManageAccountTradeConfirmation,
        },

        //=====================tax-report===========================================
        {
            path: '/ManageAccounts/tax-reports',
            name: 'ManageAccounts.ManageAccountTaxReports',
            component: ManageAccountTaxReports,
        },  
        {
            path: '/ManageAccounts/ksoft-tax-reports',
            name: 'ManageAccounts.ManageAccountKsoftTaxReports',
            component: ManageAccountKsoftTaxReports,
        },



        {
            path: '/ManageAccounts/contract-note',
            name: 'ManageAccounts.ManageAccountContractNote',
            component: ManageAccountContractNote,
        },
		{
            path: '/ManageAccounts/upload-aof-document',
            name: 'ManageAccounts.ManageAccountUploadAofDocument',
            component: ManageAccountContractNote, 
        },
		{
            path: '/ManageAccounts/closed-position',
            name: 'ManageAccounts.ManageAccountClosedPositions',
            component: ManageAccountClosedPositions, 
        },
		//-------------------------Deposits------------------------------------------------------------------------------
        {
            path: '/Deposits/history',
            name: 'Deposits.DepositHistory',
            component: DepositHistory,
        },
		//-------------------------Funds------------------------------------------------------------------------------
        {
            path: '/Funds/payin',
            name: 'Funds.FundPayin',
            component: FundPayin,
        },
        {
            path: '/Funds/payout',
            name: 'Funds.FundPayout',
            component: FundPayout,
        },
		{
            path: '/mutual-fund',
            name: 'Funds.mutualFund',
            component: mutualFund,
        },
        {
            path: '/existing-portfolio',
            name: 'Funds.exsis_portfolio',
            component: exsis_portfolio,
        },
		{
            path: '/mandate-list',
            name: 'Funds.mandate',
            component: mandate,
        },
		{
            path: '/create-mandate',
            name: 'Funds.create_mandate',
            component: create_mandate,
        },
		//-------------------------Leverages------------------------------------------------------------------------------
        {
            path: '/Leverages/compare',
            name: 'Leverages.Leveragecompare',
            component: Leveragecompare,
        },
        {
            path: '/Leverages/history',
            name: 'Leverages.Leveragehistory',
            component: Leveragehistory,
        },
		{
            path: '/LeverageIndex',
            name: 'Leverages.LeverageIndex',
            component: LeverageIndex,
        },
		//-------------------------services------------------------------------------------------------------------------
        {
            path: '/services/index/:tabName',
            name: 'services.ServicesIndex',
            component: ServicesIndex,
        },
       
		//-------------------------MarketDetails------------------------------------------------------------------------------
        {
            path: '/MarketDetails',
            name: 'MarketDetails.MarketDetails',
            component: MarketDetails,
        },

        //------------------------------Ib-list--------------------------------

        {
            path: '/referred-clients',
            name: 'referred-clients.Ib_list',
            component: notFound,   
        },
        {
            path: '/referred-list',
            name: 'referred-clients.Ib_list_new',
            component: notFound,   
        },
        {
            path: '/referal-coupon',
            name: 'couponList.couponList',
            component: notFound,
           
        },
        {
            path: '/referal-coupon/:id',
            name: 'couponList.couponList',
            component: notFound
        },
      ]
    }, 

  ]
})

Vue.use(Router)
// router.beforeEach((to, from, next) => {
//     const redirectRoutes = ['referred-clients.Ib_list', 'referred-clients.Ib_list_new', 'couponList.couponList', 'couponList'];

//     if (redirectRoutes.includes(to.name)) {
//         next({ name: 'Users.UserDashboard' });
//     } else {
//         next();
//     }
// });

const disabledRoutes = ['faq.FAQ', 'Users.api', 'Segments.McxNcdex']
router.beforeEach((to, from, next) => {
    if (disabledRoutes.includes(to.name)) {
        next({ name: 'Users.UserDashboard' })
    } else {
        next()
    }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js